const apiBaseUrl = (() => {
    if (window.location.hostname === 'localhost') {
        return 'http://localhost:3000/api'
    } else {
        return 'https://prodcopy-services-auth.oryxgaming.com/api'
    }
})() // import.meta.env.VITE_API_BASE_URL

export default {
    user: (id: string) => `${apiBaseUrl}/users/${id}`,
    users: ({ page, pageSize }: { page: number; pageSize: number }) =>
        `${apiBaseUrl}/users/?page=${page}&pageSize=${pageSize}`,
    allProjects: () => `${apiBaseUrl}/projects`,
    project: (id: string) => `${apiBaseUrl}/projects/${id}`,
    projects: ({ page, pageSize }: { page: number; pageSize: number }) =>
        `${apiBaseUrl}/projects/?page=${page}&pageSize=${pageSize}`,
    avatars: () => `${apiBaseUrl}/avatars`,
    //
    allUsers: () => {
        const localStorageUsersQuery = localStorage.getItem('users_search_query')|| '{}';
        let queryParams = (() => {
            return Object.keys(JSON.parse(localStorageUsersQuery)).map((key: string) => {
                return `${key}=${JSON.parse(localStorageUsersQuery)[key]}`;
            }).join("&");
        })();
        return `${apiBaseUrl}/users?${queryParams}`
    },
    updateUser: (id: string) => `${apiBaseUrl}/users/${id}`,
    register: () => `${apiBaseUrl}/register/new`,
    login: () => `${apiBaseUrl}/login`,
    logout: () => `${apiBaseUrl}/logout`,
    resendEmailConfirmation: () => `${apiBaseUrl}/resendEmailConfirmation`,
    sendRecoveryEmail: () => `${apiBaseUrl}/sendRecoveryEmail`,
    changePassword: () => `${apiBaseUrl}/changePassword`,
    allSessions: () => `${apiBaseUrl}/sessions`,
    getSession: (sessionId: string) => `${apiBaseUrl}/sessions/${sessionId}`,
    allStudios: () => `${apiBaseUrl}/studios`,
    permissionsPerUser: (id: string) => `${apiBaseUrl}/users/${id}/permissions`,
    permissionsPerUserUpdate: (id: string) => `${apiBaseUrl}/users/${id}/permissions`,
    //
    dashboard: () => `${apiBaseUrl}/dashboard`,
    dashboardCacheMeta: () => `${apiBaseUrl}/dashboard/cacheMeta`,
    dashboardRebuildCache: () => `${apiBaseUrl}/dashboard/rebuild/cache/full`,
    dashboardQuickSyncCache: () => `${apiBaseUrl}/dashboard/rebuild/cache/quick`,
    dashboardPartialRebuildCache: (csv: string) => `${apiBaseUrl}/dashboard/rebuild/cache/semi?keys=${csv}`,
    dashboardCert: () => `${apiBaseUrl}/dashboard/cert`,
    // logs
    clientLogs: () => `${apiBaseUrl}/logs/tracking/stats`,
    // jira
    jiraSearch: () => `${apiBaseUrl}/jira/search`,
    jiraClose: () => `${apiBaseUrl}/jira/close`,
    // cdn
    cdnOptions: () => `${apiBaseUrl}/cdn/options`,
    cdnSearch: () => `${apiBaseUrl}/cdn/search`,
    cdnRescan: () => `${apiBaseUrl}/cdn/rescan`,
    cdnRescanCdn: () => `${apiBaseUrl}/cdn/rescan-cdn`,
    cdnProgress: (scanId: string) => `${apiBaseUrl}/cdn/progress/${scanId}`,
    // export
    exportUsers: () => `${apiBaseUrl}/export/users`,
    // ips
    allIPs: () => `${apiBaseUrl}/ips`,
    resolveIP: (ip: string) => `${apiBaseUrl}/ips/resolve/${encodeURIComponent(ip)}`,
    resolveBatchIPs: () => `${apiBaseUrl}/ips/resolve-batch`,
    overwriteIP: (ip: string) => `${apiBaseUrl}/ips/${encodeURIComponent(ip)}/overwrite`,
    tagIP: (ip: string) => `${apiBaseUrl}/ips/${encodeURIComponent(ip)}/tag`,
    deleteIP: (ip: string) => `${apiBaseUrl}/ips/${encodeURIComponent(ip)}`,
}
